<script setup lang="ts">
import '../assets/style.scss'
import { computed, watchEffect } from 'vue'
import { useLoadComputedFieldValue } from './../../model/api.ts'
import { useRoute } from 'vue-router'

const props = defineProps({
  hideDetails: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: '',
  },
  field: {
    type: Object,
    default: () => {},
  },
})

const route = useRoute()
const objectId = computed(() => route.params.invent_object_id as string)
const value = defineModel<string>({ default: '' })

const { data, isLoading } = useLoadComputedFieldValue(props.field, objectId.value)

/** Получаем вычисляемое значение */
watchEffect(() => {
  if (!data.value) return

  value.value = data.value.data
})
</script>

<template>
  <VTextField
    :hide-details="hideDetails"
    :label="label"
    :readonly="true"
    :loading="isLoading"
    v-model="value"
  />
</template>
